import { Instance, SnapshotIn, SnapshotOut, types } from 'mobx-state-tree';

export const ProductAttributeValueModel = types.model('ProductAttributeValue', {
	value: types.string,
});

const AttributeModel = types.model('AttributeModel', {
	id: types.identifierNumber,
	name: types.string,
	options: types.maybeNull(types.array(types.string)),
	required: types.boolean,
	product_attribute_value: types.maybeNull(ProductAttributeValueModel),
	type: types.union(types.literal('select'), types.literal('text'), types.literal('date'), types.literal('time')),
});

export default AttributeModel;

export interface IAttributeModelModel extends Instance<typeof AttributeModel> {}

export type IAttributeModelInstance = Instance<typeof AttributeModel>;
export type IAttributeModelSnapshotIn = SnapshotIn<typeof AttributeModel>;
export type IAttributeModelSnapshotOut = SnapshotOut<typeof AttributeModel>;
